import type { Account } from "bonusx-api-main-manager";
import type { NavigateFunction } from "react-router-dom";
import { BuildGtmUserData } from "../../../../legacy/services/gtmEvent/BuildGtmUserData";
import type { EventPurchaseProps } from "../../../../legacy/services/gtmEvent/eventsSender";
import { sendGTMEventPurchase } from "../../../../legacy/services/gtmEvent/eventsSender";
import type { GTM } from "../../../../legacy/services/gtmEvent/GTMInterfaces";
import { computeTaxFromValue } from "../../../utils/computeTaxFromValue";
import { SubscriptionCheckoutQueryString } from "../entities/subscription-checkout-query-string.enum";

interface SendGTMEventCheckoutSuccessPageParams {
  accountData: Account;
  amountPaid: number;
  transactionId: string;
  items: GTM.ServiceExtended[];
}

export function sendGtmEventWhenSubscriptionIsUpdated({
  accountData,
  amountPaid,
  transactionId,
  items,
}: SendGTMEventCheckoutSuccessPageParams) {
  const userDataBuider = new BuildGtmUserData(accountData);
  const userData = userDataBuider.fromAccount();
  const tax = computeTaxFromValue(amountPaid);

  const config: EventPurchaseProps = {
    transactionId,
    value: amountPaid,
    currency: "EUR",
    userData,
    tax,
    coupon: "",
    paymentType: "chargebee",
    affiliation: "",
  };

  sendGTMEventPurchase(config, items);
}

export function afterUpgradeEvents(this: null, url: URL, navigate: NavigateFunction, currentLocationState?: unknown) {
  url.searchParams.delete(SubscriptionCheckoutQueryString.STATE);
  url.searchParams.delete(SubscriptionCheckoutQueryString.ID);
  const newPath = `${url.pathname}${url.search}`;
  navigate(newPath, { replace: true, state: currentLocationState });
}
